import { cn } from '@/lib/utils';
import { Link } from '@inertiajs/react';
import { ComponentProps } from 'react';

type LinkProps = ComponentProps<typeof Link>;

interface TextLinkProps extends LinkProps {
    variant?: 'default' | 'primary';
}

const variantClasses = {
    default: 'text-muted-foreground decoration-muted-foreground underline-offset-4 transition-colors duration-300 ease-out hover:decoration-current! hover:text-primary!',
    primary: 'text-primary decoration-primary underline-offset-4 transition-colors duration-300 ease-out hover:decoration-current! hover:text-primary!',
}

export default function TextLink({ className = '', children, variant = 'default', ...props }: TextLinkProps) {
    return (
        <Link
            className={cn(
                variantClasses[variant],
                className,
            )}
            {...props}
        >
            {children}
        </Link>
    );
}
